import { render, staticRenderFns } from "./banner-btn.vue?vue&type=template&id=94f21f68&lang=pug&"
import script from "./banner-btn.vue?vue&type=script&lang=js&"
export * from "./banner-btn.vue?vue&type=script&lang=js&"
import style0 from "./banner-btn.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports